import { render, staticRenderFns } from "./LowCredits.vue?vue&type=template&id=fface894&scoped=true&"
import script from "./LowCredits.vue?vue&type=script&lang=js&"
export * from "./LowCredits.vue?vue&type=script&lang=js&"
import style0 from "./LowCredits.vue?vue&type=style&index=0&id=fface894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fface894",
  null
  
)

export default component.exports